/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.62"
        height="84.29"
        viewBox="0 0 95.62 84.29"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M44.9 6.28V8.5h-.36l-.34.07a5.33 5.33 0 0 0-4 3.23 6.71 6.71 0 0 0-.46 3 5.18 5.18 0 0 0 2.8 4.44 21.46 21.46 0 0 0 2.31 1c1 .4 2 .78 2.91 1.19a1.74 1.74 0 0 1 1.1 1.92 1.9 1.9 0 0 1-1.54 1.93 5 5 0 0 1-1.22.13 3 3 0 0 1-3.11-2.27c-.08-.27-.15-.55-.23-.84l-3.69 1a7.59 7.59 0 0 0 1.78 3.65 6.2 6.2 0 0 0 4 1.86v2.84h2.38v-2.78c.48-.1 1-.17 1.4-.29a5.47 5.47 0 0 0 3.86-3.15 6.42 6.42 0 0 0 .48-3.89 5.11 5.11 0 0 0-2.58-3.66 31.66 31.66 0 0 0-3.53-1.54 19.61 19.61 0 0 1-2.13-1 1.54 1.54 0 0 1-.79-1 2.15 2.15 0 0 1 1.55-2.59 2.49 2.49 0 0 1 2.46.65 4.57 4.57 0 0 1 1 1.52c.08.18.15.36.24.55l3.3-1.36a6.68 6.68 0 0 0-1.21-2.5 5.89 5.89 0 0 0-4-2.09v-2.2Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M68.01 0a1.26 1.26 0 0 1 1.24 1.12v35.63h-2.5V2.5H25.01v35.31h-2.45V1.25A1.25 1.25 0 0 1 23.68.01h44.33Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M85.44 35.5a12.4 12.4 0 0 1 3.78.55 9.08 9.08 0 0 1 4.65 3 8 8 0 0 1 1.75 5.09 10.28 10.28 0 0 1-.62 3.42l-.15.37L81.64 81.3a4.9 4.9 0 0 1-4.42 3H4.6v-2.5h72.41a2.48 2.48 0 0 0 2.26-1.24l.06-.14 13.23-33.43a7.67 7.67 0 0 0 .59-2.87 5.53 5.53 0 0 0-1.19-3.52 6.82 6.82 0 0 0-3.4-2.19 9.4 9.4 0 0 0-2.64-.42H29.54a16.45 16.45 0 0 0-8.72 2.74 14.47 14.47 0 0 0-5.53 6.12l-.13.31-9.78 24.71-2.73 7a2 2 0 0 0-.15.76 2.09 2.09 0 0 0 1.91 2.09h.15v2.5a4.58 4.58 0 0 1-4.55-4.57 4.81 4.81 0 0 1 .22-1.4l.1-.26 2.74-7.06 9.78-24.71a16.68 16.68 0 0 1 6.7-7.63 19 19 0 0 1 9.62-3.12Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M23.69 18.59v2.5H9.84c-4 0-7.16 2.68-7.3 5.93V79.7H.01V27.23c0-4.73 4.28-8.5 9.51-8.64ZM72.61 24.35c5.2 0 9.64 3.9 9.79 8.66v3.71h-2.5v-3.46c0-3.35-3.19-6.28-7-6.4h-4.82v-2.5Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'FolderWithPaperMoneyIcon';

export default Icon;
